import { defineComponent as _defineComponent } from 'vue'
import { BIconCreditCard } from 'bootstrap-vue';
import { computed, ref } from 'vue';

import AmazonPayButton from '~component/redeem/payment/AmazonPayButton.vue';
import PayPalButton from '~component/redeem/payment/PayPalButton.vue';
import UnzerForm from '~component/redeem/payment/UnzerForm.vue';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Payment',
  props: {
  /* Currently selected shop as object */
  shop: {
    type: Object,
    default: null,
  },
  /* Amount to pay */
  amount: {
    type: Number,
    default: null,
  },
  /* Allow / Show the choose different value button */
  allowDifferentValue: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const selectedPayment = ref('');
const state = store?.state;
const getters = store?.getters;
const form = state.customer?.form;

const paymentOptions = computed(() => getters.getPaymentOptions);
const amazonPay = computed(() => getters.getAmazonPay);
const payPalClientId = computed(() => getters.getPayPalClientId);
const voucherValue = computed(() => getters.getVoucherBalanceInCent);
const voucherToken = computed(() => getters.getVoucherToken);
const currency = computed(() => getters.getVoucherCurrency);

const redeemValue = computed(() => form.redeemValue);
const amount = computed(() => props.amount ?? redeemValue.value - voucherValue.value);

const shopId = computed(() => props.shop?.id);
const shopName = computed(() => props.shop?.name);

return { __sfc: true,props, selectedPayment, state, getters, form, paymentOptions, amazonPay, payPalClientId, voucherValue, voucherToken, currency, redeemValue, amount, shopId, shopName, BIconCreditCard, AmazonPayButton, PayPalButton, UnzerForm }
}

})